@if (inspectionData()) {
  <wr-chart
    [labels]="inspectionLabels()"
    [showLegend]="false">
    @for (dataset of inspectionData(); track dataset.label) {
      <wr-dataset
        type="bar"
        [data]="dataset.data"
        [label]="dataset.label"
        [backgroundColor]="dataset.backgroundColor"
        indexAxis="y"
        stack="inspections">
      </wr-dataset>
    }
  </wr-chart>
}
